import { css } from 'styled-components';
import { breakpoints, colors, pxToCssFontSize, pxToRem } from '@vfit/shared/themes';
import { ILinkStyledComponent } from './link.models';

const sizes = {
  small: css`
    ${pxToCssFontSize(16)}
  `,
  big: css`
    ${pxToCssFontSize(18)}
  `,
  responsive: css`
    ${pxToCssFontSize(14)}

    @media (min-width: ${breakpoints.desktop}) {
      ${pxToCssFontSize(16)}
    }
  `,
  responsiveMedium: css`
    ${pxToCssFontSize(18)}
  `,
  responsiveBig: css`
    ${pxToCssFontSize(14)}

    @media (min-width: ${breakpoints.desktop}) {
      ${pxToCssFontSize(18)}
    }
  `,
};

const transition = css`
  transition: color 0.3s ease;

  & svg * {
    transition: stroke 0.3s ease, fill 0.3s ease;
  }
`;

const variants = {
  regular: css`
    color: ${colors.$262626};
    font-weight: 700;
    ${transition}

    &:hover {
      color: ${colors.$e60000};
    }
  `,
  breadcrumb: css`
    color: ${colors.$262626};
    ${transition};

    &:hover {
      color: ${colors.$bebebe};
    }
  `,
  white: css`
    color: ${colors.$ffffff};
  `,
  'mva:turquoise': css`
    color: ${colors.$007c92};
    text-decoration: underline;
    text-underline-offset: 4px;
  `,
};

export const common = css<ILinkStyledComponent>`
  ${({ size }) => sizes[size || 'small']}
  align-items: center;
  display: inline-flex;
  gap: ${pxToRem(8)};
  line-height: inherit;
  ${({ variant }) => variants[variant || 'regular']}

  &::selection {
    background-color: transparent;
  }
`;

// cursor: not-allowed; is ignored because pointer-events: none;
// but pointer-events: none; is necessary to disable Link from Next
export const disabled = css`
  color: ${colors.$7e7e7e};
  cursor: not-allowed;
  pointer-events: none;
  text-decoration: none;
`;
